import { enqueueEvent, markSent, wasSent } from './trackingStore';

export function pushDataLayer(payload) {
  if (typeof window === 'undefined') return false;
  if (typeof window.dataLayer === 'undefined') return false;

  window.dataLayer.push(payload);
  return true;
}

export function gtmUserData() {
  if (typeof window === 'undefined') return {};
  return window.__gtmUser || {};
}

export function buildUserPayload(overrides = {}) {
  const user = { ...gtmUserData(), ...overrides };

  return {
    ...(user.user_id && { user_id: user.user_id }),
    ...(user.email && user.email !== '-' && { email: user.email }),
    ...(user.phone && { phone: user.phone }),
    ...(user.first_name && { first_name: user.first_name }),
    ...(user.last_name && { last_name: user.last_name }),
    ...(user.city && { city: user.city }),
    ...(user.state && { state: user.state }),
    ...(user.zip && { zip: user.zip }),
    ...(user.affiliate_name && { affiliate_name: user.affiliate_name })
  };
}

export function buildEventId(eventName, identity = null) {
  const baseIdentity = identity || Date.now();
  return `${eventName}:${baseIdentity}`;
}

export function trackEvent(eventName, payload = {}, options = {}) {
  const {
    identity = null,
    persistOnRedirect = false,
    includeUserPayload = true,
    dedupe = true
  } = options;

  const runtimeIdentity = dedupe ? identity : `${Date.now()}:${Math.random().toString(36).slice(2, 8)}`;
  const eventId = buildEventId(eventName, runtimeIdentity);
  if (dedupe && wasSent(eventId)) return false;

  const eventPayload = {
    event: eventName,
    event_id: eventId,
    ts: Date.now(),
    ...(includeUserPayload ? buildUserPayload() : {}),
    ...payload
  };

  if (persistOnRedirect) enqueueEvent(eventPayload);

  const pushed = pushDataLayer(eventPayload);
  if (dedupe && pushed) markSent(eventId);

  return pushed;
}
